import { MfeRetracementLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/MfeRetracementLine';
import { MfeRetracementTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/MfeRetracementTacticPanel';
import { AddMfeRetracementTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddMfeRetracementTacticPanel';
import { MfeRetracementWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/MfeRetracementModule/MfeRetracementWrapper';
import MfeRetracementDocumentation from '../../../../components/forms/tradeplans/documentation/MfeRetracementDocumentation';
import { MfeRetracementModule } from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/MfeRetracementModule';
import { MfeRetracementData } from './mfeRetracementData';
import { validateMfeRetracement } from './validateMfeRetracement';

export const MfeRetracement = {
  //data class
  dataStore: MfeRetracementData,

  //string constants
  name: 'MFE_RETRACEMENT',
  tacticLabel: 'MFE Retracement',
  addTacticLabel: 'Add MFE Retracement',
  category: 'Exit',

  // components
  tradePlanFormModule: MfeRetracementModule,
  tacticPanel: MfeRetracementTacticPanel,
  addTacticPanel: AddMfeRetracementTacticPanel,
  wrapper: MfeRetracementWrapper,
  chartSoftOrderComponent: MfeRetracementLine,
  documentation: MfeRetracementDocumentation,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateMfeRetracement,
};
